// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__z8Bjf","disabled":"FileBtn_disabled__1PcPc","warn":"FileBtn_warn__TrCYw","fade":"FileBtn_fade__3DKXb"};